import { Box, Typography } from '@mui/material';
import { formatCurrency } from '../utils';
import { chipPaymentStatus } from '../../utils/chipPaymentStatus';
import { chipOrderStatus } from '../../utils/chipOrderStatus';

export const columns = [
    {
        field: 'CustomerName',
        headerName: 'Customer Name',
        flex: 1.5,
        minWidth: 200
    },
    {
        field: 'ItemName',
        headerName: 'Ordered Item',
        flex: 1,
        minWidth: 300,
    },
    {
        field: 'ItemQty',
        headerName: 'Qty',
        flex: 1,
        minWidth: 30,
        renderCell: (params) => (
            <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <Typography
                    sx={{
                        fontSize: 13,
                        fontWeight: 600,
                    }}
                >
                    {params.value}x
                </Typography>
            </div>
        ),
    },
    {
        field: 'Price',
        headerName: 'Price',
        flex: 1,
        minWidth: 100,
        renderCell: (params) => (
            <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <Typography
                    sx={{
                        fontSize: 13,
                        fontWeight: 600,
                    }}
                >
                    {formatCurrency(params.value)}
                </Typography>
            </div>
        ),
    },
    {
        field: 'SFee',
        headerName: 'SF',
        flex: 1,
        minWidth: 100,
        renderCell: (params) => (
            <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <Typography
                    sx={{
                        fontSize: 13,
                        fontWeight: 600,
                    }}
                >
                    {formatCurrency(params.value)}
                </Typography>
            </div>
        ),
    },
    {
        field: 'Cargo',
        headerName: 'Cargo',
        flex: 1,
        minWidth: 100,
    },
    {
        field: 'PaidAmount',
        headerName: 'Paid Amount',
        flex: 1,
        minWidth: 120,
        renderCell: (params) => (
            <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <Typography
                    sx={{
                        fontSize: Number(params.value) > 0 ? 13 : 11,
                        fontWeight: 600,
                        color: Number(params.value) > 0
                            ? '#059669'
                            : '#94A3B8',
                    }}
                >
                    {Number(params.value) > 0
                        ? formatCurrency(params.value)
                        : <em>No payment yet</em>}
                </Typography>
            </div>
        ),
    },
    {
        field: 'Balance',
        headerName: 'Balance',
        flex: 1,
        minWidth: 80,
        renderCell: (params) => (
            <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                <Typography
                    sx={{
                        fontSize: Number(params.value) > 0 ? 13 : 11,
                        fontWeight: 600,
                        color: Number(params.value) > 0
                            ? '#c71f1f'
                            : '#94A3B8',
                    }}
                >
                    {Number(params.value) > 0
                        ? formatCurrency(params.value)
                        : <em>Fully Paid</em>}
                </Typography>
            </div>
        ),
    },
    {
        field: 'PayStatus',
        headerName: 'Payment Status',
        flex: 1,
        minWidth: 130,
        renderCell: (params) => (
            <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                {chipPaymentStatus(params.value || "Pending")}
            </div>
        ),
    },
    {
        field: "OrderStat",
        headerName: "Order Status",
        flex: 1,
        minWidth: 130,
        cellClassName: "status-cell",
        renderCell: (params) => (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                }}
            >
                {chipOrderStatus(params.value)}
            </Box>
        ),
    }
];